import { Icon24Checkmark } from "@cur8/maneki";
import { ReactNode } from "react";
import { Checkbox } from "react-aria-components";
import styles from "./styles.module.sass";

interface CheckCardProps {
  "aria-label": string;
  isSelected: boolean;
  onChange: (value: boolean) => void;
  children: ReactNode;
}

export function CheckCard({
  "aria-label": ariaLabel,
  isSelected,
  onChange,
  children,
}: CheckCardProps) {
  return (
    <Checkbox
      aria-label={ariaLabel}
      isSelected={isSelected}
      onChange={onChange}
      className={styles.checkCard}
    >
      <div className={styles.content}>{children}</div>
      <div
        className={[
          styles.indicator,
          isSelected ? styles.indicatorChecked : "",
        ].join(" ")}
      >
        <Icon24Checkmark />
      </div>
    </Checkbox>
  );
}
